import moment from 'moment';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import { PPA_SOURCE_API } from '@/api';
import config from './ppaPricesConfigs';

const state = {
  tableData: [],
  tableConfig: config.fields,
};

const actions = {
  async fetchPPAPricesData({ commit }, parameters = {}) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      ppas: parameters.ppasSelected,
      startDate,
      endDate,
      marketType: parameters.marketTypesSelected,
    };
    try {
      const { data: { data } } = await PPA_SOURCE_API.post('/price/get', params);
      if (Array.isArray(data)) {
        data.forEach((x) => {
          x.tradingDate = moment(x.tradingDate).utc().format('MM/DD/YYYY');
        });
        commit('setTableData', data);
      }
    } catch (err) {
      console.error(err);
      this.$notify('Failed to load Price Data', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = Object.freeze(value);
  },
  setTableConfig(state, value) {
    state.tableConfig = value;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};